import React from "react";
import "./Footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { IoLogoTwitter } from "react-icons/io";

function Footer() {
  return (
    <footer>
      <a href="/" className="footer__logo">
        J.D. Patel
      </a>

      <ul className="permalinks">
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials">Testimonials</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/darshil.jetani.31">
          <FaFacebookF />
        </a>
        <a href="https://instagram.com/mr_darshil_5481?igshid=YmMyMTA2M2Y=">
          <FiInstagram />
        </a>
        <a href="https://twitter.com/Darshiljetani54">
          <IoLogoTwitter />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; J.D. Patel. All rights reserved</small>
      </div>
    </footer>
  );
}

export default Footer;
